import { Button, Form, Input, Modal, Typography } from 'antd';
import { connect } from 'react-redux';
import { fetchVideoDataFromURL } from './actions/contentCreation';
import { Duration } from "luxon";
import { useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const ImportFromUrl = ({ addVideosToVideoBank, fetchVideoDataFromURL, setVisible, videoType, visible }) => {

    const [form] = Form.useForm();
    const [importInProgress, setImportInProgress] = useState(false);


    const handleOnFinish = ({ url }) => {
        const handleOnNewVideoByURLError = () => {
            setImportInProgress(false);
            return form.setFields([{
                name: 'url',
                errors: ["Invalid video or playlist URL"]
            }])
        }
        setImportInProgress(true);
        fetchVideoDataFromURL(url.trim(), parseVimeoData, parseYouTubeData, handleOnNewVideoByURLError)
    }

    const parseYouTubeData = (data) => {
        let newVideos = data['data']['items'].map(item => {
            let videoId = item['id']
            let videoDuration = Duration.fromISO(item['contentDetails']['duration']).shiftTo('seconds').seconds;
            return {
                'title': item['snippet']['title'],
                'videoType': data['videoType'],
                'embedId': videoId,
                'importedFromURL': "true",
                'duration': videoDuration
            }
        })
        let videosToImport = newVideos.concat(data['licensableContent'])
        addVideosToVideoBank(videosToImport)
        setVisible(false);
        setImportInProgress(false);
        form.resetFields()
    }
    const parseVimeoData = (data) => {
        let newVideos;
        if (data['contentType'] === "playlist") {
            newVideos = data['data']['data'].map(videoData => {
                return {
                    'title': videoData['name'],
                    'videoType': data['videoType'],
                    'embedId': videoData['uri'].replace('/videos/', ''),
                    'duration': videoData['duration']
                }
            })
        } else if (data['contentType'] === 'video') {
            newVideos = data['data'].map(videoData => {
                return {
                    'title': videoData['name'],
                    'videoType': data['videoType'],
                    'embedId': videoData['uri'].replace('/videos/', ''),
                    'duration': videoData['duration']
                }
            })
        }
        let videosToImport = newVideos.concat(data['licensableContent'])
        addVideosToVideoBank(videosToImport)
        setImportInProgress(false);
        setVisible(false);
        form.resetFields()
    }

    return <>
        <Form
            onFinish={handleOnFinish}
            form={form}
            layout="vertical"
            name="basic"
            className="import-more-video-form"
            initialValues={{ url: "" }}
            autoComplete="off"
        >
            <Form.Item
                name="url"
                rules={[{
                    required: true,
                    message: "Please enter a valid playlist or video URL"
                }]}
            >
                <Input placeholder="Import videos from YouTube or Vimeo URL" />
            </Form.Item>
            <Button
                type="primary"
                loading={importInProgress}
                icon={<DownloadOutlined />}
                htmlType="submit"></Button>
        </Form>
    </>
}

export default connect(null, { fetchVideoDataFromURL })(ImportFromUrl);